/**
 * Copyright (C) 2019 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */

import { ManualDowntimePeriod } from '../../shared/entities/manualDowntimePeriod';
import { Action, ActionCreators } from './actions';

export interface State {
  readonly manualDowntimePeriods: ManualDowntimePeriod[] | undefined;
  readonly isRequestingManualDowntimePeriods: boolean;
  readonly isManualDowntimePeriodsRequestFinished: boolean;
  readonly requestManualDowntimePeriodsError?: string;

  readonly isAddingManualDowntimePeriod: boolean;
  readonly addedManualDowntimePeriodSuccess: boolean;
  readonly addedManualDowntimePeriodError?: string;

  readonly isDeletingManualDowntimePeriod: boolean;
  readonly deletedManualDowntimePeriodSuccess: boolean;
  readonly deletedManualDowntimePeriodError?: string;
}

export const initialManualDowntimePeriodsState: State = {
  manualDowntimePeriods: undefined,

  isRequestingManualDowntimePeriods: false,
  isManualDowntimePeriodsRequestFinished: false,
  requestManualDowntimePeriodsError: undefined,

  isAddingManualDowntimePeriod: false,
  addedManualDowntimePeriodSuccess: false,
  addedManualDowntimePeriodError: undefined,

  isDeletingManualDowntimePeriod: false,
  deletedManualDowntimePeriodSuccess: false,
  deletedManualDowntimePeriodError: undefined,
};

export default function reducer(state: State = initialManualDowntimePeriodsState, action: Action): State {
  let partialState: Partial<State> | undefined;

  switch (action.type) {
    case ActionCreators.RequestManualDowntimePeriods.type:
      partialState = {
        manualDowntimePeriods: undefined,
        isRequestingManualDowntimePeriods: true,
        isManualDowntimePeriodsRequestFinished: false,
        requestManualDowntimePeriodsError: undefined,
      };
      break;

    case ActionCreators.ReceivedManualDowntimePeriodsSuccess.type: {
      partialState = {
        manualDowntimePeriods: action.payload.response,
        isRequestingManualDowntimePeriods: false,
        isManualDowntimePeriodsRequestFinished: true,
        requestManualDowntimePeriodsError: undefined,
      };
      break;
    }

    case ActionCreators.ReceivedManualDowntimePeriodsError.type:
      partialState = {
        isRequestingManualDowntimePeriods: false,
        isManualDowntimePeriodsRequestFinished: true,
        requestManualDowntimePeriodsError: action.payload.message,
      };
      break;

    case ActionCreators.ClearManualDowntimePeriods.type:
      partialState = {
        manualDowntimePeriods: undefined,
        isRequestingManualDowntimePeriods: false,
        isManualDowntimePeriodsRequestFinished: true,
        requestManualDowntimePeriodsError: undefined,
      };
      break;

    case ActionCreators.AddManualDowntimePeriod.type:
      partialState = {
        isAddingManualDowntimePeriod: true,
        addedManualDowntimePeriodSuccess: false,
        addedManualDowntimePeriodError: undefined,
      };
      break;

    case ActionCreators.AddedManualDowntimePeriodSuccess.type: {
      partialState = {
        isAddingManualDowntimePeriod: false,
        addedManualDowntimePeriodSuccess: true,
        addedManualDowntimePeriodError: undefined,
        manualDowntimePeriods: [...(state?.manualDowntimePeriods || []), action.payload.response],
      };
      break;
    }

    case ActionCreators.AddedManualDowntimePeriodError.type:
      partialState = {
        isAddingManualDowntimePeriod: false,
        addedManualDowntimePeriodSuccess: false,
        addedManualDowntimePeriodError: action.payload.message,
      };
      break;

    case ActionCreators.DeleteManualDowntimePeriod.type:
      partialState = {
        isDeletingManualDowntimePeriod: true,
        deletedManualDowntimePeriodSuccess: false,
        deletedManualDowntimePeriodError: undefined,
      };
      break;

    case ActionCreators.DeletedManualDowntimePeriodSuccess.type: {
      partialState = {
        isDeletingManualDowntimePeriod: false,
        deletedManualDowntimePeriodSuccess: true,
        deletedManualDowntimePeriodError: undefined,
      };
      break;
    }

    case ActionCreators.DeletedManualDowntimePeriodError.type:
      partialState = {
        isDeletingManualDowntimePeriod: false,
        deletedManualDowntimePeriodSuccess: false,
        deletedManualDowntimePeriodError: action.payload.message,
      };
      break;
    case ActionCreators.RemoveManualDowntimePeriodFromStoreById.type:
      partialState = {
        manualDowntimePeriods: [
          ...(state?.manualDowntimePeriods || []).filter(
            (manualDowntimePeriod: ManualDowntimePeriod) => manualDowntimePeriod.id !== action.payload,
          ),
        ],
      };
      break;
    default:
      return state;
  }
  return { ...state, ...partialState };
}
